import { z } from 'zod'

export const schema = z.object({
  fund_name: z.string().min(1),
  currency: z.string().min(1),
  fund_long_name: z.string().min(1),
  platform_name: z.string().optional(),
})

export type SchemaType = z.infer<typeof schema>
